import React, { useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import XMLViewer from "react-xml-viewer";
import { TransitionProps } from "@mui/material/transitions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloseIcon from "@mui/icons-material/Close";
import { closePreview, selectorXmlExport } from "./XmlExportSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { CopyAll } from "@mui/icons-material";
import {CopyToClipboard} from 'react-copy-to-clipboard';

export default function XmlPreviewModal() {
  const dispatch = useAppDispatch();
  const xmlExport = useAppSelector(selectorXmlExport);
  const ref = useRef<HTMLAnchorElement | null>(null);

  const [copied, setCopied] = useState<boolean>(false);

  const handleClose = () => {
    dispatch(closePreview());
  };

  function handleDownload() {
    ref.current?.click();
  }

  const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  return (
    <Dialog
      open={true}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth={true}
      maxWidth="lg"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <Box sx={{ display: "flex", px: 2 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            XML Preview
          </Typography>
          <Button
            startIcon={<CloudDownloadIcon />}
            sx={{ px: 2 }}
            onClick={handleDownload}
          >
            Download
          </Button>
          <CopyToClipboard
            text={xmlExport.xmlData}
            onCopy={(e) => setCopied(true)}
          >
            <CopyAll/>
          </CopyToClipboard>
          {copied ? <Typography>Copied!</Typography>: null}

          <IconButton
            aria-label="close"
            onClick={(e) => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <XMLViewer xml={xmlExport.xmlData} />
      </DialogContent>
      <a
        href={URL.createObjectURL(new Blob([xmlExport.xmlData]))}
        download="ResearchOnDemand_Survey.xml"
        className="hidden"
        ref={ref}
      />
    </Dialog>
  );
}
